import { ChangeStagesEnum } from 'config/environments/shared';
import { CadastralChangeEnum } from 'helpers';

import { getStepByAddress } from '../getStepByAddress';
import { getStepByEmail } from '../getStepByEmail';
import { getStepByPhone } from '../getStepByPhone';

export const getStep = (type: string, pathname: string): ChangeStagesEnum | undefined => {
  if (type === CadastralChangeEnum.phone) {
    return getStepByPhone(pathname);
  }

  if (type === CadastralChangeEnum.address) {
    return getStepByAddress(pathname);
  }

  if (type === CadastralChangeEnum.email) {
    return getStepByEmail(pathname);
  }

  return undefined;
};
